import React, { useState } from "react";
import { motion } from "framer-motion";
import * as S from "./style";
import { Sidebar } from "../../components/Sidebar";
import { Topnav } from "../../components/Topnav";


const HomeLayout = ({ children, heading }) => {
  const [openSidebar, setOpen] = useState(true);

  return (
    <S.LayoutWrapper>
      {/* Top Nav */}
      <S.FixedTopnav>
        <Topnav />
      </S.FixedTopnav>

      <S.BodyWrapper>
        {/* Sidebar */}
        <motion.div
          variants={S.sidebarVariants}
          animate={openSidebar ? "open" : "closed"}
          initial={false}
          style={{ overflow: "hidden", flexShrink: 0 }}
        >
          <S.SidebarWrapper open={openSidebar}>
            <Sidebar>
              <motion.div
                variants={S.toggleIconVariants}
                animate={openSidebar ? "open" : "closed"}
                transition={{ duration: 0.2 }}
              >
                <S.LeftArrowCircle onClick={() => setOpen(!openSidebar)} />
              </motion.div>
            </Sidebar>
          </S.SidebarWrapper>
        </motion.div>

        {/* Content */}
        <S.ContentWrapper open={openSidebar}>
          <S.PageHeader>{heading}</S.PageHeader>

          <motion.div
            variants={S.pageVariants}
            initial="initial"
            animate="animate"
            key={heading}
          >
            {children}
          </motion.div>
        </S.ContentWrapper>
      </S.BodyWrapper>
    </S.LayoutWrapper>
  );
};

export default HomeLayout;
